import { AuthConfig } from 'angular-oauth2-oidc';
import { environment } from '@env';

export const authConfig: AuthConfig = {
  // URL of the SPA to redirect the user to after login
  redirectUri: `${window.location.origin}`,

  // Preserve the requested route including query parameters after code flow login.
  // This setting enables deep linking for the code flow.
  preserveRequestedRoute: true,

  requireHttps: environment.production,

  // Enables OAuth2 'Authorization Code Flow'
  responseType: 'code',

  // Is necessary because Keycloak does not provide the 'at_hash' property in the ID token.
  // It is only delivered when response_type is 'code id_token' which is not supported by angular-oauth2-oidc
  disableAtHashCheck: true,

  // set the scope for the permissions the client should request
  scope: 'openid profile email',

  oidc: true
};
